import {inject} from "vue";

class Loader {
    visible = true;
    options = {
        transition: 1000,
        selector: '.app-loader'
    }

    constructor(options) {
        this.options = Object.assign(this.options, options);
    }

    _getLoader() {
        return document.querySelector(this.options.selector);
    }

    hide() {
        const element = this._getLoader();
        if (!element) return;
        element.style.transition = `opacity linear ${this.options.transition}ms`;
        element.style.opacity = '0';
        setTimeout(() => {
            element.style.display = 'none';
        }, this.options.transition);
    }

    show() {
        const element = this._getLoader();
        if (!element) return;
        element.style.display = null;
        element.style.opacity = '1';
    }

    setMode(mode) {
        this._getLoader().classList.remove('light', 'dark');
        this._getLoader().classList.add(mode);
    }
}
export default {
    install(app, options = {}) {
        const loader = new Loader(options);
        app.provide('loader', loader);
        app.config.globalProperties.$loader = loader;
    }
}

export function useLoader() {
    return inject('loader');
}